import React from 'react';

const BarChart = ({ data, width, height }) => {
  const maxValue = 100; // Fixed maximum value for the y-axis
  const barWidth = width / data.length;
  const dayLabels = ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5']; // Labels for the days

  return (
    <svg width={width} height={height}>
      {data.map((value, index) => {
        const barHeight = (value / maxValue) * height;
        const barX = index * barWidth;
        const barY = height - barHeight;

        return (
          <g key={index}>
            <rect
              x={barX}
              y={barY}
              width={barWidth - 2} // Leave some space between bars
              height={barHeight}
              fill="rgb(249, 115, 22)" // Custom orange color
            />
            <text
              x={barX + (barWidth - 2) / 2}
              y={barY - 5}
              textAnchor="middle"
              fill="black"
              fontSize="12"
            >
              ${value}
            </text>
            <text
              x={barX + (barWidth - 2) / 2}
              y={height + 15}
              textAnchor="middle"
              fill="black"
              fontSize="12"
            >
              {dayLabels[index]}
            </text>
          </g>
        );
      })}
    </svg>
  );
};

export default BarChart;
